import CustomProperty from "./Modules/CustomProperty.js";

CustomProperty();